'use strict';

exports.__esModule = true;
exports['default'] = thunkMiddleware;

function thunkMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  var getState = _ref.getState;

  return function (next) {
    return function (action) {
      return typeof action === 'function' ? action(dispatch, getState) : next(action);
    };
  };
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-thunk/lib/index.js
 ** module id = 177
 ** module chunks = 0
 **/